import { App, defineAsyncComponent } from 'vue'

const CatalogAppointment = defineAsyncComponent(() => import('./CatalogAppointment.vue'))
const Catalog = defineAsyncComponent(() => import('./Catalog.vue'))
const FacilityCatalogMap = defineAsyncComponent(() => import('./FacilityCatalogMap.vue'))
const PreviewMap = defineAsyncComponent(() => import('./PreviewMap.vue'))

const install = (app: App<Element>, prefix = 'Doctor'): void => {
  app
    .component(`${prefix}CatalogAppointment`, CatalogAppointment)
    .component(`${prefix}Catalog`, Catalog)
    .component(`${prefix}FacilityCatalogMap`, FacilityCatalogMap)
    .component(`${prefix}PreviewMap`, PreviewMap)
}

export default {
  install,
}
